<template>
	<div>
		<div class="image_tofile" ref="imageTofile">
		　　<img src="../../assets/login_img.jpg" />
		</div>
		  <el-button type="success" @click="toImage">保存</el-button>
		<img :src="htmlUrl" class="show_img">
	</div>
</template>

<script>
	import html2canvas from 'html2canvas'
	export default{
		data(){
			return{
				htmlUrl: ''
			}
		},
		components: {
		　　html2canvas
		},
		methods:{
			// 页面元素转图片
			　　toImage() {
			　　　　// 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
			　　　　html2canvas(this.$refs.imageTofile, {
			　　　　　　backgroundColor: null
			　　　　}).then((canvas) => {
					console.log(canvas)
					let link = document.createElement("a");
					        // link.href = canvas.toDataURL();//下载链接
					        // link.setAttribute("download","体检表.png");
					        // link.style.display = "none";//a标签隐藏
					        // document.body.appendChild(link);
					        // link.click();
					
			　　　　　　let url = canvas.toDataURL('image/png');
			　　　　　　this.htmlUrl = url;
			　　　　　　// 把生成的base64位图片上传到服务器,生成在线图片地址
			// 　　　　　　this.sendUrl();
			　　　　})
			　　},
			　　// 图片上传服务器
			// 　　sendUrl () {
			// 　　　　// 如果图片需要formData格式,就自己组装一下,主要看后台需要什么参数
			// 　　　   // const formData = new FormData()
			// 　　　　// formData.append('base64', this.company.fileUrl)
			// 　　　　// formData.append('userId', 123)
			// 　　　　// formData.append('pathName', 'pdf')
			// 　　　　this.$ajax({
			// 　　　　　　url: apiPath.common.uploadBase,
			// 　　　　　　method: 'post',
			// 　　　　　　data: this.htmlUrl
			// 　　　　}).then(res => {
			// 　　　　　　if (res.code && res.data) {
			 
			// 　　　　　　}
			// 　　　　})
			// 　　}
		}
	}
</script>

<style lang="less">
	.image_tofile {
		width: 200px; height: 500px;
		img {
			width: 100%; height: 100%;
		}
	}
	.show_img {
		// width: 200px; height: 500px;
	}
</style>
